import { render, staticRenderFns } from "./ThemesButton.vue?vue&type=template&id=ac37aeb4&scoped=true"
import script from "./ThemesButton.vue?vue&type=script&lang=js"
export * from "./ThemesButton.vue?vue&type=script&lang=js"
import style0 from "./ThemesButton.vue?vue&type=style&index=0&id=ac37aeb4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac37aeb4",
  null
  
)


    import installComponents from "!/home/gitlab-runner/builds/_LQxgyuP/0/skolkovo/frontend/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BButton} from 'bootstrap-vue'
    installComponents(component, {BButton})
    

export default component.exports